import { GanttConfig } from '../../../GanttConfig';
import { ganttFormatters } from '../../../utils';

type VirtualHourUnitProps = {
  value: Date;
  resolution: number;
};

export const VirtualHourUnit = ({ resolution, value }: VirtualHourUnitProps) => {
  const dataAttributes = {
    [ganttFormatters.dateTimeAttribute]: ganttFormatters.formatDate(value),
  };

  const width = GanttConfig.SINGLE_ELEMENT_WIDTH / resolution;

  return <span className="box-border h-4 border-l border-border-primary" {...dataAttributes} style={{ width }} />;
};
